import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { db } from "../firebase/firebase";

import {
    doc,
    getDoc,
    setDoc,
} from "firebase/firestore";

export default function Courses() {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [courses, setCourses] = useState([]);

    const [newCourse, setNewCourse] = useState({
        title: "",
        id: "",
    });

    const [editingIndex, setEditingIndex] = useState(null);

    const [editingValue, setEditingValue] = useState("");

    /* ---------------- FETCH COURSES ---------------- */
    useEffect(() => {

        fetchCourses();

    }, []);

    const fetchCourses = async () => {

        try {

            const snap = await getDoc(
                doc(db, "course", "allCourses")
            );

            if (snap.exists()) {

                setCourses(
                    snap.data().courses || []
                );

            }

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }
    };

    /* ---------------- SAVE ---------------- */
    const saveCourses = async (
        updatedCourses
    ) => {

        try {

            await setDoc(
                doc(
                    db,
                    "course",
                    "allCourses"
                ),
                {
                    courses: updatedCourses,
                }
            );

            setCourses(updatedCourses);

        } catch (err) {

            console.error(err);

            alert("Failed ❌");

        }
    };

    /* ---------------- ADD ---------------- */
    const handleAddCourse = async () => {

        if (!newCourse.title.trim()) {

            return alert(
                "Enter course title"
            );
        }

        if (!newCourse.id.trim()) {

            return alert(
                "Enter course ID"
            );
        }

        const alreadyExists =
            courses.some(
                (c) =>
                    c.id ===
                    newCourse.id
            );

        if (alreadyExists) {

            return alert(
                "Course ID already exists"
            );
        }

        const updated = [
            ...courses,

            {
                id: newCourse.id,

                title:
                    newCourse.title,

                slug: "",

                shortDescription:
                    "",

                category: "",

                duration: "",

                isPopular: false,

                seo: {
                    seoTitle: "",
                    seoDescription:
                        "",
                    seoKeywords: [],
                },

                media: {
                    banner: "",
                    thumbnail: "",
                    logo: "",
                    img: "",
                },

                outcomes: [],

                faqs: [],

                testimonials: [],

                projects: {
                    core: [],
                    jobReady: [],
                    pro: [],
                },

                tiers: [],
            },
        ];

        await saveCourses(updated);

        setNewCourse({
            title: "",
            id: "",
        });
    };

    /* ---------------- DELETE ---------------- */
    const handleDelete = async (
        index
    ) => {

        const confirmDelete =
            window.confirm(
                "Delete this course?"
            );

        if (!confirmDelete) return;

        const updated =
            courses.filter(
                (_, i) => i !== index
            );

        await saveCourses(updated);
    };

    /* ---------------- EDIT ---------------- */
    const handleEdit = (
        index,
        value
    ) => {

        setEditingIndex(index);

        setEditingValue(value);
    };

    /* ---------------- UPDATE ---------------- */
    const handleUpdate = async (
        index
    ) => {

        if (
            !editingValue.trim()
        ) {

            return alert(
                "Course name required"
            );
        }

        const updated = [
            ...courses,
        ];

        updated[index] = {
            ...updated[index],

            title:
                editingValue.trim(),
        };

        await saveCourses(updated);

        setEditingIndex(null);

        setEditingValue("");
    };

    if (loading) {

        return (
            <div className="text-white">
                Loading...
            </div>
        );
    }

    return (

        <div className="text-white">

            {/* HEADER */}
            <div className="flex justify-between items-center mb-8">

                <div>

                    <h1 className="text-3xl font-bold text-orange-500">
                        Courses
                    </h1>

                    <p className="text-slate-400 mt-1">
                        Manage all institute
                        courses
                    </p>

                </div>

                <button
                    onClick={() =>
                        navigate(-1)
                    }
                    className="bg-white/10 hover:bg-white/20 transition-all px-4 py-2 rounded-lg"
                >
                    Back
                </button>

            </div>

            {/* ADD COURSE */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8">

                <h2 className="text-lg font-semibold mb-4">
                    Add New Course
                </h2>

                <div className="grid md:grid-cols-3 gap-4">

                    <input
                        type="text"
                        value={
                            newCourse.title
                        }
                        onChange={(e) =>
                            setNewCourse({
                                ...newCourse,

                                title:
                                    e.target
                                        .value,
                            })
                        }
                        placeholder="Course Title"
                        className="p-3 rounded-xl bg-black/40 border border-white/20"
                    />

                    <input
                        type="text"
                        value={
                            newCourse.id
                        }
                        onChange={(e) =>
                            setNewCourse({
                                ...newCourse,

                                id: e.target.value
                                    .toLowerCase()
                                    .replace(
                                        /\s+/g,
                                        "-"
                                    ),
                            })
                        }
                        placeholder="Course ID (example: web-dev)"
                        className="p-3 rounded-xl bg-black/40 border border-white/20"
                    />

                    <button
                        onClick={
                            handleAddCourse
                        }
                        className="bg-orange-500 hover:bg-orange-600 transition-all px-6 py-3 rounded-xl font-medium"
                    >
                        Add Course
                    </button>

                </div>

            </div>

            {/* COURSE LIST */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">

                {courses.map(
                    (
                        course,
                        index
                    ) => (

                        <div
                            key={index}
                            className="bg-white/5 border border-white/10 rounded-2xl p-5 hover:border-orange-500/40 transition-all"
                        >

                            {/* EDIT MODE */}
                            {editingIndex ===
                                index ? (

                                <div className="space-y-4">

                                    <input
                                        type="text"
                                        value={
                                            editingValue
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setEditingValue(
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                        className="w-full p-3 rounded-xl bg-black/40 border border-white/20"
                                    />

                                    <div className="flex gap-3">

                                        <button
                                            onClick={() =>
                                                handleUpdate(
                                                    index
                                                )
                                            }
                                            className="flex-1 bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg"
                                        >
                                            Save
                                        </button>

                                        <button
                                            onClick={() => {

                                                setEditingIndex(
                                                    null
                                                );

                                                setEditingValue(
                                                    ""
                                                );

                                            }}
                                            className="flex-1 bg-gray-600 hover:bg-gray-700 px-4 py-2 rounded-lg"
                                        >
                                            Cancel
                                        </button>

                                    </div>

                                </div>

                            ) : (

                                <>

                                    <div className="mb-4">

                                        <h3 className="text-lg font-semibold">
                                            {
                                                course.title
                                            }
                                        </h3>

                                        <p className="text-sm text-slate-400 mt-1">
                                            ID:
                                            {" "}
                                            {
                                                course.id
                                            }
                                        </p>

                                    </div>

                                    <div className="flex flex-wrap gap-3">

                                        <button
                                            onClick={() =>
                                                navigate(
                                                    `/dashboard/course-view?id=${course.id}`
                                                )
                                            }
                                            className="flex-1 bg-orange-500 hover:bg-orange-600 transition-all px-4 py-2 rounded-lg text-sm"
                                        >
                                            View
                                        </button>

                                        <button
                                            onClick={() =>
                                                handleEdit(
                                                    index,
                                                    course.title
                                                )
                                            }
                                            className="flex-1 bg-blue-600 hover:bg-blue-700 transition-all px-4 py-2 rounded-lg text-sm"
                                        >
                                            Edit
                                        </button>

                                        <button
                                            onClick={() =>
                                                handleDelete(
                                                    index
                                                )
                                            }
                                            className="flex-1 bg-red-600 hover:bg-red-700 transition-all px-4 py-2 rounded-lg text-sm"
                                        >
                                            Delete
                                        </button>

                                    </div>

                                </>

                            )}

                        </div>

                    )
                )}

            </div>

            {/* EMPTY */}
            {courses.length ===
                0 && (

                    <div className="bg-white/5 border border-dashed border-white/10 rounded-2xl p-10 text-center text-slate-400">

                        No courses found

                    </div>

                )}

        </div>
    );
}